import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import ConfigService from './config-service.js';
import * as ons from 'onsenui';

const env_localhost = require('../environments/environment.localhost.js');
const env_local     = require('../environments/environment.local.js');
const env_dev       = require('../environments/environment.development.js');
const env_stg       = require('../environments/environment.staging.js');
const env_prd       = require('../environments/environment.production.js');

export default new class ApiService extends Vue {
  static POSITION = 'POSITION';
  static AREA_SEARCH = 'AREA_SEARCH';
  static AREA_INFO = 'AREA_INFO';
  static GET_CONTENTS = 'GET_CONTENTS';
  static CONDITIONS_SEARCH = 'CONDITIONS_SEARCH';
  static SUGGESTION = 'SUGGESTION';
  static DETAIL = 'DETAIL';

  /**
   * 位置情報検索機能
   * @returns 
   */
  position(data) {
    return this.getApiObject(ApiService.POSITION, data);
  }

  /**
   * エリア検索機能
   * @returns 
   */
  areaSearch(data) {
    return this.getApiObject(ApiService.AREA_SEARCH, data);
  }

  /**
   * エリア情報（区、エリア名取得）
   * @returns 
   */
  areaInfo() {
    return this.getApiObject(ApiService.AREA_INFO);
  }

  /**
   * 店舗ATM簡易情報
   * @returns 
   */
  getContents(data) {
    return this.getApiObject(ApiService.GET_CONTENTS, data);
  }

  /**
   * 条件検索
   * @returns 
   */
  conditionsSearch() {
    return this.getApiObject(ApiService.CONDITIONS_SEARCH);
  }

  /**
   * サジェスト機能
   * @returns 
   */
  suggestion() {
    return this.getApiObject(ApiService.SUGGESTION);
  }

  /**
   * 店舗・ATM 詳細取得
   * @returns 
   */
   detail(data) {
    return this.getApiObject(ApiService.DETAIL, data);
  }

  /**
   * API通信を行い、結果を返却します
   * @param  {string} apiKey environment API key名
   * @param  {object} data   paramater
   */
  getApiObject(apiKey, data) {
    const environment = this.getCurrentEnv(ConfigService.getCurrentEnv());
    const apiInfo = environment.apiInfos[apiKey];
    const apiBaseUrl = environment.apiUrl;
    const apiUrl = ConfigService.getCurrentEnv() === 'LOCALHOST' ? `${location.origin}/${apiInfo.path}` : apiBaseUrl + apiInfo.path;
    const appToken = localStorage.getItem('ncbatm.appToken');
    if (apiInfo.method === 'POST') {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${appToken}`
      };

      let instance;
      instance = axios.create({
        baseURL: apiBaseUrl,
        headers: headers
      });

      return instance.post(apiUrl, this.setParams(data))
        .then(async function(response) {
          if (response.data.ok) {
            return response.data;
          } else {
            ons.notification.alert({
              'title': '',
              'messageHTML': `${response.data.error_message}`
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          ons.notification.alert({
            'title': '',
            'messageHTML': `${error.error_message}`
          });
        });
    } else {
      const headers = {
        'Cache-Control': 'no-cache',
        'Authorization': `Bearer ${appToken}`
      };

      const instance = axios.create({
        baseURL: apiBaseUrl,
        headers: headers
      });

      return instance.get(apiUrl, this.setParams(data))
        .then(async function(response) {
          if (response.data.ok) {
            return response.data;
          } else {
            ons.notification.alert({
              'title': '',
              'messageHTML': `${response.data.error_message}`
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          ons.notification.alert({
            'title': '',
            'messageHTML': `${error.error_message}`
          });
        });
    }
  }
  
  /**
   * 環境を返却します
   * @param {string} current dotenv変数[VUE_APP_NODE_ENV]
   */
  getCurrentEnv(current) {
    let current_env = '';

    switch (current) {
      case 'LOCALHOST':
        current_env = env_localhost;
        break;

      case 'LOCAL':
        current_env = env_local;
        break;

      case 'DEVELOPMENT':
        current_env = env_dev;
        break;

      case 'STAGING':
        current_env = env_stg;
        break;

      case 'PRODUCTION':
        current_env = env_prd;
        break;

      default:
        current_env = env_localhost;
        break;
    }

    return current_env;
  }

  /**
   * パラメーターを返却します
   * @param {object} parameters パラメーター
   */
  setParams(parameters) {
    return parameters;
  }
}
